export default {
  blindBox: {
    userType:'用户类型',
    userTypeName:'用户类型名称',

    addType:'新增类型',
    prize:'奖励',
    editPrize:'编辑奖励',

    addUser:'添加用户',
  }
}



// WEBPACK FOOTER //
// ./src/language/blindBox-zh-cn.js